import { render, staticRenderFns } from "./MewTabs.vue?vue&type=template&id=853200ce&scoped=true"
import script from "./MewTabs.vue?vue&type=script&lang=js"
export * from "./MewTabs.vue?vue&type=script&lang=js"
import style0 from "./MewTabs.vue?vue&type=style&index=0&id=853200ce&prod&lang=scss"
import style1 from "./MewTabs.vue?vue&type=style&index=1&id=853200ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853200ce",
  null
  
)

export default component.exports